@if (primaryType) {
<!-- Primeiro tipo de card (layout original) -->
<div class="upload-card" [ngClass]="{'upload-card--has-file': hasFile}">
  <div class="upload-card__content">

    <!-- Estado sem arquivo -->
    @if (!hasFile) {
    <ng-container>
      <div class="upload-card__icon">
        <mat-icon>description</mat-icon>
      </div>
      <div class="upload-card__title">
        {{ title }}
      </div>
      <div class="upload-card__subtitle">
        {{ subtitle }}
      </div>
      <div class="upload-card__button-container">
        <input type="file" id="file-upload" class="upload-card__file-input" (change)="onFileSelected($event)"
          [accept]="acceptedFileTypes" />
        <label for="file-upload" class="upload-card__button upload-card__button--upload">
          {{ buttonText }}
        </label>
      </div>
    </ng-container>
    }

    <!-- Estado com arquivo -->
    @if (hasFile) {
    <ng-container>
      <div class="upload-card__title">
        {{ title }}
      </div>
      <div class="upload-card__filename">
        @if (isFileNameEditable) {
        <input type="text" [value]="fileName" (input)="onFileNameChange($event.target.value)"
          class="upload-card__filename-input" />
        } @else {
        <span class="upload-card__filename-text">
          {{ fileName }}
        </span>
        }
      </div>
      <div class="upload-card__subtitle">
        {{ displaySubtitle }}
      </div>
      <div class="upload-card__button-container">
        <button class="upload-card__button upload-card__button--delete" (click)="onDeleteFile()">
          EXCLUIR ARQUIVO
        </button>
      </div>
    </ng-container>
    }

  </div>
</div>
} @else if (secondType) {
<!-- Segundo tipo de card (novo layout) -->
<div class="upload-card-second">
  <div class="upload-card-second__content">
    @if (!hasFile) {
    <ng-container>

      <div class="upload-card-second__icon">
        <mat-icon [svgIcon]="'iconUpload'"></mat-icon>
      </div>
      <div class="upload-card-second__title">
        Clique ou arraste e solte o arquivo
      </div>
      <div class="upload-card-second__subtitle">
        {{ subtitle }}
      </div>
      <input type="file" id="file-upload-second" class="upload-card-second__file-input"
        (change)="onFileSelected($event)" [accept]="acceptedFileTypes" />
    </ng-container>
    }

    <!-- Estado com arquivo -->
    @if (hasFile) {
    <ng-container>
      <div class="upload-card__title">
        {{ title }}
      </div>
      <div class="upload-card__filename">
        @if (isFileNameEditable) {
        <input type="text" [value]="fileName" (input)="onFileNameChange($event.target.value)"
          class="upload-card__filename-input" />
        } @else {
        <span class="upload-card__filename-text">
          {{ fileName }}
        </span>
        }
      </div>
      <div class="upload-card__subtitle">
        {{ displaySubtitle }}
      </div>
      <div class="upload-card__button-container">
        <button class="upload-card__button upload-card__button--delete" (click)="onDeleteFile()">
          Excluir arquivo
        </button>
      </div>
    </ng-container>
    }
  </div>
</div>
} @else if (tertiaryType) {
<!-- Terceiro tipo de card (novo layout) -->
<div class="upload-card-tertiary">
  <div class="button-container">
    <input type="file" id="file-upload" class="file-input" (change)="onFileSelected($event)"
      [accept]="acceptedFileTypes" />
    <label for="file-upload" class="button-upload">
      <div class="upload-icon">
        <mat-icon [svgIcon]="'simpleUpload'"></mat-icon>
      </div>
      {{ buttonText }}
    </label>
  </div>
</div>
}